export const gerCurrentView = (viewList) => {
  return viewList[viewList.length - 1];
};

export const addCommasToNumber = (number) => {
  const formatter = new Intl.NumberFormat('en-IN');
  return formatter.format(number);
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const getValueByKey = (object, key) => {
  return object[key];
};

export const serializeAndMergeEquipment = (
  newEquipment = [],
  existingEq = [],
  customerId
) => {
  const flatAssetInfoArray = [];
  const equipmentObjectStructure = {
    brand: '',
    customerId: '',
    equipmentId: '',
    equipmentType: '',
    model: '',
    ownership: '',
    price: '',
    purchaseDate: '',
    rcNumber: '',
    existing: true,
  };
  for (let i = 0; i < existingEq.length; i++) {
    existingEq[i]?.AssetInfo?.forEach((asset) => {
      flatAssetInfoArray.push(asset);
    });
  }

  const equipmentArray = flatAssetInfoArray.map((asset) => {
    const equipmentObjectStructureTemp = {...equipmentObjectStructure};
    equipmentObjectStructureTemp.brand = asset.manufacturerName;
    equipmentObjectStructureTemp.customerId = customerId;
    equipmentObjectStructureTemp.equipmentId = asset.assetNumber;
    equipmentObjectStructureTemp.equipmentType = asset.product;
    equipmentObjectStructureTemp.model = asset.modelNum;
    equipmentObjectStructureTemp.ownership = 'Owned';
    equipmentObjectStructureTemp.price = 'N/A';
    equipmentObjectStructureTemp.rcNumber = asset.registrationNum;

    return equipmentObjectStructureTemp;
  });

  return [...newEquipment, ...equipmentArray];
};

export const getAllEquipmentList = (equipmentList) => {
  let equipmentListObj = {};
  equipmentList && equipmentList.length > 0
    ? equipmentList.map((equipment) => {
        let key =
          equipment.equipmentType === 'Tractor'
            ? equipment.brand + ' ' + equipment.model + ' ' + equipment.rcNumber
            : equipment.implementType;
        let value = equipment.equipmentId;
        equipmentListObj[key] = value;
      })
    : null;
  return equipmentListObj;
};

export const getDateFormatDD = (timestamp) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  let date = new Date(timestamp);
  let dd = String(date.getDate()).padStart(2, '0');
  let mm = monthNames[date.getMonth()];
  let yyyy = date.getFullYear();

  date = dd + ' ' + mm + ' ' + yyyy;
  return date;
};

export const getExpensesOfType = (
  props,
  showDropDownExp,
  selectValue,
  otherExpenses
) => {
  let expensesOfType =
    props.expenseInformation &&
    props.expenseInformation.find((exps) => {
      return exps.type === props.expenseType;
    });

  if (
    showDropDownExp.indexOf(props.expenseType) > -1 &&
    selectValue !== 'SHOW_ALL'
  ) {
    const expObjKeyValue = {
      tractor: {
        key: 'eqipId',
        value: getAllEquipmentList(props.allEquipments)[selectValue],
      },
      other: {key: 'otherExpenseType', value: selectValue},
    };
    let filterData;
    if (selectValue === 'OTHER') {
      filterData = expensesOfType.detail.filter(
        (exp) => !otherExpenses.includes(exp.otherExpenseType)
      );
    } else {
      filterData = expensesOfType.detail.filter((exp) => {
        return (
          exp[expObjKeyValue[props.expenseType].key] ===
          expObjKeyValue[props.expenseType].value
        );
      });
    }
    let filterDataTotal = filterData.reduce((acc, obj) => {
      return acc + Number(obj.amount);
    }, 0);
    expensesOfType = {
      ...expensesOfType,
      detail: filterData,
      total: filterDataTotal,
    };
  }
  return expensesOfType;
};
